import { MessageTypes } from "@app/pippa/models";
import type { EventDataMessageType } from "@app/pippa/models";
import type { ChatHistoryMessage } from "@app/pippa/hooks/useApiController";

const DISPLAYABLE_ROLES = ["user", "assistant"];

export function buildHistoryMessages(
  history: ChatHistoryMessage[],
  introMessage: EventDataMessageType
): EventDataMessageType[] {
  const filtered = history.filter(
    (m) => DISPLAYABLE_ROLES.includes(m.role) && m.content
  );
  const transformed: EventDataMessageType[] = filtered.map((msg) => ({
    id: msg.messageId,
    type: MessageTypes.TEXT,
    text: msg.content,
    isSendByUser: msg.role === "user",
    createdAt: msg.createdAt,
    quickReplies: msg.quickReplies,
    feedback: msg.feedback,
    feedbackEligible: msg.feedbackEligible,
    reaction: msg.reaction,
  }));
  return [introMessage, ...transformed];
}
